export default __webpack_public_path__ + "static/media/transations.6415b2ae.svg";